// extracted by mini-css-extract-plugin
export var external__menu = "externalLinks-module--external__menu--73r8c";